/*
 *
 *  A module for toggling a css class.
 * 
 *  Pass the parent element and then the css class you wish to toggle on
 *  its children
 * 
 *  Implementation:
 *
 *  import { toggleNavItem } from 'path-to-file.ts';
 *  let toggleInstance = new toggle( '[data-nav]', 'active' );
 *
 */

export function toggleCssClass(selector: string, cssClass:string) {
    const navList: HTMLUListElement = document.querySelector(selector);
    if(!navList || !navList.children)
        return;
        
    const navItems = Array.from(navList.children);

    navItems.forEach((item) => {
        item.addEventListener('click', () => {

            navItems.forEach((item) => {
                item.classList.remove(cssClass);
            })

            if(!item.classList.contains(cssClass)) {
                item.classList.add(cssClass);
            }
        });
    });
}